import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ProtectedAdminRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const sessionToken = localStorage.getItem('admin_session_token');
      const adminUser = localStorage.getItem('admin_user');

      if (!sessionToken || !adminUser) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Parse stored admin user
      const adminUserData = JSON.parse(adminUser);
      
      // Check if user has admin flag
      if (adminUserData && adminUserData.is_admin) {
        // User is admin, allow access
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }
      
      // Optionally: Verify session is still valid with backend
      /* const response = await axios.get(`${API}/auth/me`, {
        headers: {
          'Cookie': `session_token=${sessionToken}`
        },
        withCredentials: true
      });

      // If we reach here, verification passed
      setIsAuthenticated(true); */
    } catch (error) {
      console.error('Auth check failed:', error);
      // Session invalid, clear storage
      localStorage.removeItem('admin_session_token');
      localStorage.removeItem('admin_user');
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Abel, sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔐</div>
          <div>Authentifizierung wird überprüft...</div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
